import React from 'react';

import { Button, Typography } from '@mui/material';
import _ from 'lodash';

import { ReactComponent as ChevronRightIconSmallGray } from '../../../../common/assets/icons/chevron_right_icon_small_gray.svg';
import { SelectableCode } from '../../../../common/types/Codes';

type CodeExtraInfoProps = {
  code: SelectableCode;
  onClick: () => void;
};

export const ModifiersButton: React.FC<CodeExtraInfoProps> = ({
  code,
  onClick,
}) => {
  return (
    <Button
      sx={{
        borderRadius: '40px',
        flexShrink: 0,
        maxHeight: '40px',
        border: '1px solid #D9E9ED',
        display: 'flex',
      }}
      onClick={() => onClick()}
      color={'appGray'}
      variant={'outlined'}
      endIcon={<ChevronRightIconSmallGray />}
    >
      <Typography
        sx={{
          flexDirection: 'row',
          display: 'flex',
          whiteSpace: 'break-spaces',
          maxWidth: '240px',
        }}
        noWrap
        color='darkBlue'
        fontWeight={700}
      >
        Modifier:{' '}
      </Typography>
      {_.isEmpty(code.modifiers) ? (
        <Typography noWrap color='rgba(82, 86, 98, 0.60)' fontWeight={700}>
          None
        </Typography>
      ) : (
        <Typography noWrap color='primary.main' fontWeight={700}>
          {code.modifiers.join('; ')}
        </Typography>
      )}
    </Button>
  );
};
